import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '../../../../@fuse/pipes/pipes.module';
import { StatusBadgeModule } from '../status-badge/status-badge.module';
import { WarrantyStatusBadgeComponent } from './warranty-status-badge.component';

@NgModule({
  entryComponents: [
    WarrantyStatusBadgeComponent
  ],
  imports: [
    CommonModule,
    StatusBadgeModule,
    PipesModule
  ],
  declarations: [
    WarrantyStatusBadgeComponent
  ],
  exports: [
    WarrantyStatusBadgeComponent
  ]
})
export class WarrantyStatusBadgeModule {}
